import { php } from '@/plugins/api/endpoints';

export default {
    // Get all API keys
    async getApiKeys() {
        return await php.get('/api-key');
    },

    // Create new API key
    async createApiKey(data) {
        return await php.post('/api-key', data);
    },

    // Update API key
    async updateApiKey(id, data) {
        return await php.put(`/api-key/${id}`, data);
    },

    // Delete API key
    async deleteApiKey(id) {
        return await php.delete(`/api-key/${id}`);
    },

    // Get external API modules
    async getExternalApiModules() {
        return await php.get('/api-key/external-api-modules');
    },

    // Get scopes for specific API key
    async getApiKeyScopes(id) {
        return await php.get(`/api-key/${id}/scopes`);
    }
};
